module.exports = __webpack_public_path__ + "img/操作简单.050639c1.svg";